import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import styled from "styled-components";
import PartDetails from "./PartDetails";
import Inventory from "./Inventory";
import AddToCart from "../AddToCart";
import "../../styling/styles.css";
import PriceLabel from "./PriceLabel";
import { getGasket } from "../../../customParts/helpers";
import { Helmet } from "react-helmet";

const Wrapper = styled.div`
  clear: both;
  margin-bottom: 16px;
  min-height: 80px;
  width: 800px;
  box-shadow: 0 2px 4px 0 var(--black-19);
  border: solid 1px var(--very-light-grey);
  background-color: "white"};
`;
const Row = styled.div`
  font-family: "Roboto", sans-serif;
  margin-left: 17px;
  margin-right: 17px;
  color: var(--black);
`;
const Row1 = styled(Row)`
  margin-top: 11px;
`;
const Description = styled.span`
  font-size: 16px;
  font-weight: bold;
`;
const ErrorMessage = styled(Description)`
  color: red;
`;
const HelpMessage = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: var(--greyish-brown);
  margin-top: 20px;
`;
const PriceLabelWrapper = styled.span`
  float: right;
  font-size: 12px;
  font-weight: normal;
  margin-top: 10px;
  margin-right: 12px;
  vertical-align: text-bottom;
  color: var(--battleship-grey);
`;
const Price = styled.span`
  float: right;
  margin-top: 8px;
  margin-right: 12px;
  font-size: 16px;
  font-weight: bold;
`;
const CallForPrice = styled.span`
  float: right;
  margin-top: 8px;
  margin-right: 12px;
  font-size: 12px;
  font-weight: normal;
`;
const Row2 = styled(Row)`
  margin: 0px 0px 8px 0px;
`;
const PartLabel = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: var(--greyish-brown);
`;
const PartNumber = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: var(--greyish-brown);
`;
const ExistingCount = styled.div`
  float: right;
  font-style: italic;
  font-size: 13px;
  color: #f06721;
  margin-top: -6px;
  &:hover {
    background-color: var(--highlight-orange);
    color: black;
  }
`;
const Button = styled.button`
  float: right;
  color: white;
  width: 180px;
  height: 34px;
  border-radius: 2px;
  border: solid 2px var(--reddish-orange);
  background-color: var(--reddish-orange);
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
`;

const formatPrice = price => (price ? `$${Number.parseFloat(price).toFixed(2)}` : "Call");

export default function Part(props) {
  const [quantity, setQuantity] = useState(1);
  const context = useContext(AppContext);
  const { cartParts } = context;
  const cartQuantity = cartParts ? cartParts.reduce((q, p) => (p.partId === props.partId ? q + p.quantity : q), 0) : 0;
  const gasket = getGasket(props.partId);

  return (
    <Wrapper isHighlighted={props.isHighlighted}>
      {gasket && (
        <>
          <Row1>
            <Description>{gasket.title}</Description>
            <Button
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                props.history.push(`/custom/gasket/${gasket.partId}`);
              }}
            >
              Customize
            </Button>
            <Row2>
              <PartLabel>Part #: </PartLabel>
              <PartNumber>{gasket.partId}</PartNumber>
            </Row2>
          </Row1>
          <PartDetails
            attributes={[
              { name: "Color", value: gasket.color },
              { name: "Material", value: gasket.material }
            ]}
          />
        </>
      )}
      {!gasket && (props.title || props.attributes) && (
        <>
          <Row1>
            <Description>{props.title ? props.title : "No part description"}</Description>
            <AddToCart
              partId={props.partId}
              title={props.title}
              onAddToCart={props.onAddToCart}
              quantity={quantity}
              setQuantity={setQuantity}
              discontinued={props.partStatus === 3}
              inventory={props.inventory}
              cartQuantity={cartQuantity}
            />
            {!!props.price && (
              <>
                <Price>{formatPrice(props.price)}</Price>
                <PriceLabelWrapper>
                  <PriceLabel />
                </PriceLabelWrapper>
              </>
            )}
            {!props.price && <CallForPrice>Call for price</CallForPrice>}
            <Row2>
              <PartLabel>Part #: </PartLabel>
              <PartNumber>{props.partId}</PartNumber>
            </Row2>
            {cartQuantity ? (
              <Link to="/cart">
                <ExistingCount>{`${cartQuantity} in your cart`}</ExistingCount>
              </Link>
            ) : (
              ""
            )}
            <Inventory inventory={props.inventory} quantity={quantity + cartQuantity} discontinued={props.partStatus === 3}/>
          </Row1>
          {props.attributes && props.attributes.length > 0 && <PartDetails attributes={props.attributes} />}
        </>
      )}
      {props.partId && !props.title && !props.attributes && (
        <>
          <Helmet>
            <meta name="prerender-status-code" content="404" />
          </Helmet>
          <Row1>
            <ErrorMessage>PartId not found</ErrorMessage>
            <Row2>
              <PartLabel>Part #: </PartLabel>
              <PartNumber>{props.partId}</PartNumber>
              <HelpMessage>Please double-check your part number or search again for equivalent part.</HelpMessage>
            </Row2>
          </Row1>
        </>
      )}
    </Wrapper>
  );
}
